import React from 'react';
import { GMStatuses } from 'Components/utils/customer-account/ca.constants';
import { t } from 'Src/i18n';
import { ResponsiveTabs } from 'Components/frameworks/responsive-tabs/ResponsiveTabs';
import { GreatMembersAccordionContent } from './GreatMembersAccordionContent';
type Props = {
  status: GreatMembersStatus | null | undefined;
};

const getTabsItems = () =>
  GMStatuses.map((st) => ({
    header: {
      color: `gm-${st}`,
      title: t(`customerAccount.greatMember.stasusesSection.tabs.${st}.label`),
    },
    headerId: st.substring(0, 1),
    content: [<GreatMembersAccordionContent key={st} status={st} />],
  }));

const getTabToOpenFromUserStatus = (status) => {
  const lowerCaseUserStatus = status && status.toLowerCase();
  const index = GMStatuses.indexOf(lowerCaseUserStatus);
  return index > 0 ? index : 0;
};

export const GreatMembersAccordion = ({ status }: Props) => (
  <ResponsiveTabs
    areAllCollapsable
    hasBackground
    initialSelectedItems={[getTabToOpenFromUserStatus(status)]}
    items={getTabsItems()}
  />
);
